import HealthChart from "./health-chart.vue";

export default HealthChart;



// WEBPACK FOOTER //
// ./src/components/_charts/health/index.js